import Super from 'client-portal/controllers/-request/confirmation';

export default class WidgetRequestConfirmation extends Super {}
